/*
 * Copyright (C) 2018 - 2023. Entgra (Pvt) Ltd, https://entgra.io
 * All Rights Reserved.
 *
 * Unauthorized copying/redistribution of this file, via any medium
 * is strictly prohibited.
 * Proprietary and confidential.
 *
 * Licensed under the Entgra Commercial License,
 * Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 *
 * You may obtain a copy of the License at
 * https://entgra.io/licenses/entgra-commercial/1.0
 */

import React, { useState, useContext } from 'react';
import { Button, Col, Divider, Row, Steps } from 'antd';
import ConfigContext from '../../../../../../../../components/ConfigContext';
import { useTranslation, withTranslation } from 'react-i18next';
const { Step } = Steps;

import Content from './components/Content';

const ManualEnrollmentGuide = props => {
  const [current, setCurrent] = useState(0);
  const { t } = useTranslation();
  const { config } = useContext(ConfigContext);

  const next = () => {
    setCurrent(current + 1);
  };

  const previous = () => {
    setCurrent(current - 1);
  };

  const { enrollmentSteps, deviceType } = props;
  const enrollmentHeader = `${deviceType.substring(0, 1).toUpperCase() +
    deviceType.substring(1)} ${t('label_enrollment_instruction')}`;

  return (
    <>
      <Steps current={current} style={{ marginBottom: '24px' }}>
        {enrollmentSteps.map((step, index) => (
          <Step key={index} />
        ))}
      </Steps>
      <Row>
        <Col span={8}>
          <h3 id="enrollmentTitle">{enrollmentHeader}</h3>
          <p>{props.enrollmentDescription}</p>
          <p>
            {t('label_needHelp')} {t('label_read')}&nbsp;
            <a
              href={`https://docs.entgra.io/${config.serverVersion}/enrollment/#${props.enrollmentGuideId}`}
              target={'_blank'}
            >
              {t('label_ioTServerDoc')}
            </a>
          </p>
          <Divider />
          <Content {...enrollmentSteps[current]} />
          <div>
            {current > 0 && (
              <Button
                style={{ marginRight: '10px' }}
                onClick={() => previous()}
              >
                Previous
              </Button>
            )}
            {current < enrollmentSteps.length - 1 && (
              <Button type={'primary'} onClick={() => next()}>
                Next
              </Button>
            )}
          </div>
        </Col>
        <Col span={16}>
          <img
            src={enrollmentSteps[current].stepImg}
            width={'100%'}
            height={'auto'}
          />
        </Col>
      </Row>
    </>
  );
};

export default withTranslation()(ManualEnrollmentGuide);
